
export enum ServiceLevelPartyTypeCd {
	BILL_TO = 'Bill-To',
	CONSIGNEE = 'Consignee',
	DEBTOR = 'Debtor',
	SHIPPER = 'Shipper'}

